import React from "react";
import soulMateSearchImg from "../../../assets/projects/soulMate.png";
import { FiGithub } from "react-icons/fi";
import { FiExternalLink } from "react-icons/fi";

const Project2 = () => {
  const soulMateSearch = {
    projectName: "2. Soul Mate Search",
    image: soulMateSearchImg,
    description:
      "Soul Mate Search is a dedicated matrimony website, designed to help individuals find their perfect life partners. With user-friendly features and comprehensive profiles, SoulMateSearch simplifies the journey to finding love and companionship. Join SoulMateSearch today and embark on the path to a lifelong connection.",
    technologies: [
      "React",
      "Javascript",
      "Tailwind CSS",
      "MongoDB",
      "Express.js",
      "JWT",
      "Firebase",
    ],
    gitHub: "https://github.com/Bikash-Dev-Bk/soul-mate-search-client",
    live: "https://soul-mate-search.web.app/",
  };

  return (
    <div className="lg:max-w-[1200px] mx-auto flex flex-col lg:flex-row gap-5 justify-between py-20 px-6 md:px-12 lg:px-2">
      <div className="flex-1">
        <img src={soulMateSearch.image} alt="" />
      </div>
      <div className="flex-1 ">
        <h1 className="text-2xl font-bold ">{soulMateSearch.projectName}</h1>
        <p className="text-justify mt-5">{soulMateSearch.description}</p>

        <div>
          <h2 className="text-xl font-semibold my-4">Technology</h2>
          <ul>
            {soulMateSearch.technologies.map((tech, index) => (
              <li key={index} className="flex gap-1 items-center">
                🔷<span> {tech}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-10 flex gap-5">
          <p className="bg-[#2979ff] text-white px-5 py-2 rounded">
            <a
              href={soulMateSearch.gitHub}
              target="_blank"
              rel="noreferrer"
              className="flex gap-2 items-center"
            >
              <FiGithub className="text-2xl " />{" "}
              <span className="font-semibold">Code</span>
            </a>
          </p>
          <p className="bg-[#2979ff] text-white px-5 py-2 rounded">
            <a
              href={soulMateSearch.live}
              target="_blank"
              rel="noreferrer"
              className="flex gap-2 items-center"
            >
              <FiExternalLink className="text-2xl " />
              <span className="font-semibold">Live</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Project2;
